import { DatePicker, Select, FieldWrapper } from '@td-client-frontend/common';
import _ from 'lodash';
import moment from 'moment';
import React, { useMemo, useState } from 'react';

import { terminationReasons, TERMINATION_REASON_OTHER } from '../../../constants/formConstants';

interface TermModalProps {
  selectedGroup: any;
  onDateChange: (value: any) => void;
  onReasonChange: (value: any) => void;
  initialValue: string;
}

export const TermModal = ({ selectedGroup, onDateChange, onReasonChange, initialValue }: TermModalProps) => {
  const [termDate, setTermDate] = useState<string>(initialValue || '');
  const [termReason, setTermReason] = useState<string>('');
  const [terminationNotes, setTerminationNotes] = useState<string>();
  const [terminationNotesError, setTerminationNotesError] = useState<boolean>(false);

  const handleTerminationReasonChange = (value: string) => {
    setTermReason(value);

    if (value !== TERMINATION_REASON_OTHER) {
      onReasonChange(value);
    } else {
      onReasonChange(null);
    }
  };

  const handleTerminationNotesChange = (value: string) => {
    setTerminationNotes(value);

    if (value.length < 3) {
      setTerminationNotesError(true);
      onReasonChange(null);
    } else {
      setTerminationNotesError(false);
      onReasonChange(value);
    }
  };

  const termReasons = useMemo(() => {
    return _.orderBy(terminationReasons, ['label']);
  }, []);
  return (
    <section className="p-6 space-y-4 font-bold font-effra">
      <p className="inline">
        You are about to terminate {selectedGroup?.name || 'this group'}. Are you sure you would like to proceed?
      </p>
      <div className="flex flex-col space-y-2">
        <div className="flex space-x-2">
          <div className="w-1/3">
            <DatePicker
              label="Termination Date"
              value={termDate ? moment(termDate).format('MM/DD/YYYY') : ''}
              minDate={moment().utc().subtract(59, 'days').toDate()}
              onChange={(value: any) => {
                const formattedDate = moment(value, 'yyyy-MM-DD');
                setTermDate(value);
                onDateChange(formattedDate);
              }}
            />
          </div>
          <div className="w-2/3">
            <Select
              name="terminationReason"
              options={termReasons}
              value={termReason}
              label="Reason for Termination"
              placeholder="Please select reason"
              onChange={handleTerminationReasonChange}
              error=""
              maxVisible={3}
              isError={false}
              required
            />
          </div>
        </div>
        {termReason === TERMINATION_REASON_OTHER && (
          <div>
            <FieldWrapper
              label="Notes *"
              name="terminationNotes"
              isError={terminationNotesError}
              error={terminationNotesError ? 'Termination reason should be at least 3 charackers in length' : undefined}
            >
              <textarea
                name="terminationNotes"
                value={terminationNotes}
                className="form-field overflow-hidden h-auto min-h-12 bg-white p-3 resize-none"
                placeholder=""
                rows={5}
                maxLength={100}
                onChange={(e) => handleTerminationNotesChange(e.target.value)}
              />
            </FieldWrapper>
          </div>
        )}
      </div>
    </section>
  );
};
